module.exports = __webpack_public_path__ + "media/images/official/ogimage_community-5a100707c5bf4e61b3b21f7942845693.jpg";